// Color constants for PropertiesTree component (values map to the `neutral`
// palette in src/index.css's @theme block).
export const COLORS = {
  ARCHIVED_TEXT: '#A3A9B9', // neutral-40
  NON_ARCHIVED_TEXT: '#696F88', // neutral-60
  ARCHIVED_FIELD_ICON: '#C2C7D0', // neutral-30
  NON_ARCHIVED_FIELD_ICON: '#868CA2', // neutral-50
  // Crop zones render as an outlined shape (fill + field-color border) to stay
  // visually distinct from a field's solid fill. Archived crop zones use a
  // lighter, muted pair.
  CROP_ZONE_ICON_FILL: '#DFE2E7', // neutral-20 (non-archived fill)
  CROP_ZONE_ICON_FILL_ARCHIVED: '#F3F4F6' // neutral-10 (archived fill)
} as const;

// Padding levels for tree hierarchy - BY_FARM sorting
export const TREE_PADDING = {
  CROP: 'pl-8',
  FARM: 'pl-8',
  FIELD: 'pl-12',
  CROP_ZONE: 'pl-16'
} as const;

// Padding levels for tree hierarchy - BY_CROP sorting
export const TREE_PADDING_BY_CROP = {
  CROP: 'pl-8',
  FARM: 'pl-12',
  FIELD: 'pl-16',
  CROP_ZONE: 'pl-20'
} as const;

// Icon sizes
export const ICON_SIZES = {
  FIELD: 26,
  CROP: 14
} as const;
